export default angular
  .module('st.Search', ['st.Core', 'angular-cache'])
  .service('searchService', ($http, $rootScope, CacheFactory, dataService, SEARCH) => {
    let cache;
    if (!CacheFactory.get(SEARCH.CACHE.NAME)) {
      cache = CacheFactory(SEARCH.CACHE.NAME, SEARCH.CACHE.STORE);
    }
    const cacheKey = (params, requestName) =>
      JSON.stringify({
        idAccount: $rootScope.CurrentAccount.id,
        idOrganization: $rootScope.CurrentOrganization.id,
        type: requestName || SEARCH.CACHE.NAME,
        params
      });
    return {
      clearCache: () => cache.removeAll(),
      getAvailable: (params) =>
        dataService.apiRequest(
          cache,
          cacheKey(params),
          params?.ignoreCache === true,
          null,
          $http.get,
          SEARCH.API.AVAILABLE,
          { params }
        ),
      getContacts: (params) =>
        dataService.apiRequest(
          cache,
          cacheKey(params),
          params?.ignoreCache === true,
          null,
          $http.get,
          SEARCH.API.CONTACTS,
          { params }
        ),
      getTickets: (params) =>
        dataService.apiRequest(
          cache,
          cacheKey(params),
          params?.ignoreCache === true,
          null,
          $http.get,
          SEARCH.API.TICKETS,
          { params }
        ),
      getWorkflows: (params) =>
        dataService.apiRequest(
          cache,
          cacheKey(params),
          params?.ignoreCache === true,
          null,
          $http.get,
          SEARCH.API.WORKFLOWS,
          { params }
        )
    };
  })
  .constant('SEARCH', {
    API: {
      AVAILABLE: '/api/v1/search',
      CONTACTS: '/api/v1/search/contacts',
      TICKETS: '/api/v1/search/tickets',
      WORKFLOWS: '/api/v1/search/workflows'
    },
    CACHE: {
      NAME: 'searchCache',
      STORE: {
        maxAge: 60 * 1000,
        deleteOnExpire: 'aggressive',
        recycleFreq: 30 * 1000,
        storageMode: 'sessionStorage'
      }
    }
  });
